import {
    ListItem,
    ListItemButton,
    ListItemProps,
    ListItemText,
} from '@mui/material';
import {Basket} from '../../types';
import {useTranslation} from 'react-i18next';
import {replaceHighlight} from '../Media/Asset/Attribute/AttributeHighlights.tsx';
import {Classes} from '../../classes.ts';

type Props = {
    data: Basket;
    selected?: boolean;
    onClick?: () => void;
    disabled?: boolean;
} & Pick<ListItemProps, 'onContextMenu'>;

export default function BasketMenuItem({
    data,
    onClick,
    selected,
    onContextMenu,
    disabled,
}: Props) {
    const {t} = useTranslation();

    return (
        <>
            <ListItem onContextMenu={onContextMenu} disablePadding>
                <ListItemButton
                    selected={selected}
                    role={undefined}
                    onClick={onClick}
                    disabled={disabled}
                >
                    <ListItemText
                        className={Classes.ellipsisText}
                        primary={
                            data.nameHighlight
                                ? replaceHighlight(data.nameHighlight)
                                : data.name ||
                                  t('basket.default.title', 'My Basket')
                        }
                        secondary={
                            disabled
                                ? t(
                                      'basket.disabled.label',
                                      `You don't have permission to edit this basket`
                                  )
                                : data.descriptionHighlight
                                  ? replaceHighlight(data.descriptionHighlight)
                                  : data.description
                        }
                        secondaryTypographyProps={{
                            style: {whiteSpace: 'normal'},
                        }}
                    />
                </ListItemButton>
            </ListItem>
        </>
    );
}
